<template>
  <!--
    인증 상태 변경
  -->

  <v-row justify="center">
    <v-dialog v-model="authStateDialog" max-width="420px">
      <v-card>
        <v-card-title>인증상태 변경</v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pb-0">
          <p class="font-weight-bold mt-7 body-2 black--text">
            인증상태 수정시 참고해주세요.
          </p>
          <p class="mb-0 font-weight-bold caption">
            상태 변경시에 고객이 쇼핑몰의 정품 인증 페이지에서
          </p>
          <p class="mb-0 font-weight-bold caption">
            변경사항 확인이 가능하게 됩니다.
          </p>
          <p class="mb-0 font-weight-bold caption">
            참고하여 운영에 활용하시길 권장합니다.
          </p>

          <p class="mb-2 font-weight-bold body-2 black--text text-truncate mt-7">
            현재 인증상태는
            <font class="deep-purple--text pb-2">{{ statusText }}</font>
            상태입니다.
          </p>

          <v-col class="pt-3 pl-0 ma-0 pb-3 pr-0">
            <v-col cols="12" class="pa-0 ma-0">
              <v-select
                v-model="selectStatus"
                :items="authStateTypeItems"
                label="Select"
                persistent-hint
                single-line
                hide-details
                class="pt-0"
                outlined
                dense
                height="50"
                @change="changeCheckMemberShow"
              ></v-select>
            </v-col>
          </v-col>
          <v-col class="col-auto mr-auto mr-0 ml-0 pr-0 pl-0 pt-0 pb-2 d-flex" v-if="checkMemberShow">
            <v-select
              v-model="selectMemberType"
              :items="memberTypeItems"
              label="Select"
              persistent-hint
              single-line
              hide-details
              class="pt-0"
              outlined
              dense
              height="50"
              :style="{ width: '80px' }"
              @change="changeMemberType"
            ></v-select>
            <v-text-field
              :disabled="memberIdChecked"
              v-model="memberId"
              outlined
              dense
              height="50px"
              placeholder="회원 ID 입력"
              class="ml-3 d-inline-block"
              :style="{ width: '170px' }"
              hide-details=""
            ></v-text-field>
          </v-col>
          <v-col class="pl-0 pr-0 pt-0 " v-if="!memberIdChecked && checkMemberShow">
            <v-btn
              :disabled="memberIdChecked"
              x-large
              color="grey darken-4"
              class="white--text d-inline-block pl-0 pr-0"
              width="100%"
              @click.prevent="validateUser"
              >유효성 체크</v-btn
            >
          </v-col>
        </v-card-text>
        <v-card-text v-if="checkMemberShow && (memberIdChecked || selectMemberType === 'guest')" class="pt-0 pb-3">
          <v-col v-if="selectMemberType === 'guest'" class="pl-0 pr-0">
            <p class="mb-0 font-weight-bold caption black--text mr-4" style="align-content:center;">
              비회원 인증시 아래 정보를 입력해주세요.
            </p>
          </v-col>
          <v-col class="d-flex pl-0 pr-0" v-else-if="memberIdChecked">
            <p class="mb-0 font-weight-bold caption black--text mr-4" style="align-content:center;">
              쇼핑몰 회원 확인이 되었습니다.
            </p>
            <v-btn small color="blue" class="white--text" @click="memberOpen()">회원 CRM 연결</v-btn>
          </v-col>
          <v-col class="pl-0 pr-0 pt-0">
            <p class="mb-0 caption">
              고객의 이름, 이메일, 휴대번호 정보를 입력해주세요.<br />
              ‘회원 CRM 연결’ 버튼을 클릭하여 확인이 가능합니다.<br />
              해당 정보를 통해 다음과 같이 처리됩니다.
            </p>
            <ul class="caption">
              <li>
                [정품 인증 회원 관리] 메뉴<br />
                이름, 전화번호(휴대전화), 이메일 정보를 확인 할 수 있어요.
              </li>
              <li>
                [카톡/SMS/메일 발송 관리] 메뉴<br />
                인증상태 변경시 카톡/SMS/메일 발송을 할 수 있어요.
              </li>
            </ul>
          </v-col>
          <v-col class="pl-0 pr-0 pb-0">
            <v-text-field
              v-model="memberName"
              outlined
              dense
              height="50px"
              placeholder="이름 입력"
              class="d-inline-block"
              :style="{ width: '100%' }"
              hide-details=""
            ></v-text-field>
          </v-col>
          <v-col class="pl-0 pr-0 pb-0">
            <v-text-field
              v-model="memberPhone"
              outlined
              dense
              height="50px"
              placeholder="전화번호 입력"
              class="d-inline-block"
              :style="{ width: '100%' }"
              hide-details=""
            ></v-text-field>
          </v-col>
          <v-col class="pl-0 pr-0 pb-0">
            <v-text-field
              v-model="memberEmail"
              outlined
              dense
              height="50px"
              placeholder="이메일 입력"
              class="d-inline-block"
              :style="{ width: '100%' }"
              hide-details=""
            ></v-text-field>
          </v-col>
        </v-card-text>
        <v-divider class="mt-2"></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="authStateDialog = false">닫기</v-btn>
          <v-btn color="blue darken-1" text @click.prevent="changeStatus">저장</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import M from "@/libs/mapping.js";
import CommonMixin from "@/mixins/CommonMixin.js";

export default {
  data() {
    return {
      prd: null,
      memberIdChecked: false,
      authStateDialog: false,
      selectStatus: "",
      statusText: "",
      memberId: "",
      checkMemberShow: false,
      is_save: false,
      initTypeItems: [
        { text: "변경할 인증상태 선택", value: "" },
        { text: "미인증", value: "inactivated" },
        { text: "인증완료", value: "activated" },
        { text: "승인완료", value: "approved" },
        { text: "분실", value: "lost" },
      ],
      authStateTypeItems: [],
      memberName: "",
      memberPhone: "",
      memberEmail: "",
      selectMemberType: "member",
      memberTypeItems: [
        { text: "회원", value: "member" },
        { text: "비회원", value: "guest" },
      ],
    };
  },
  mixins: [CommonMixin],
  async created() {
    await this.waitForShopNo();
    this.initData();
  },
  methods: {
    /**
     * 초기화
     */
    initData: function() {
      this.prd = null;
      this.memberIdChecked = false;
      this.memberId = "";
      this.selectStatus = "";
      this.statusText = "";
      this.authStateTypeItems = [];
      this.checkMemberShow = false;
      this.selectMemberType = "member";
      this.memberName = "";
      this.memberPhone = "";
      this.memberEmail = "";
      this.initTypeItems = [
        { text: "변경할 인증상태 선택", value: "" },
        { text: "미인증", value: "inactivated" },
        { text: "인증완료", value: "activated" },
        { text: "승인완료", value: "approved" },
        { text: "분실", value: "lost" },
      ];
    },
    /**
     * 상태변경 다이얼 시작
     */
    authStateClick: async function(data) {
      console.log("start modal check");
      this.initData();
      await this.getApproval(data);
      await this.getSerialStatus(data.serial_number);
      this.prd = data;
      let statusIndex = this.initTypeItems.findIndex((item) => item.value === data.cert_status);
      this.statusText = this.initTypeItems[statusIndex].text;
      this.initTypeItems.forEach((item, index) => {
        if (index !== statusIndex) {
          // mallType이 imweb일 때 '분실' 값 제거
          if (!(this.$store?.state?.mallType === "imweb" && item.value === "lost")) {
            this.authStateTypeItems.push(item);
          }
        }
      });
      this.authStateDialog = true;
    },
    /**
     * 상태변경 체크
     */
    changeStatus: async function() {
      if (this.is_save) {
        console.log("change Status click");
        return;
      }
      if (this.selectStatus === "") {
        this.alertShow("변경할 인증상태를 선택해주세요.");
        return false;
      }
      let payload = {
        cert_status: this.selectStatus,
      };

      if (this.checkMemberShow === true) {
        if (!this.memberIdChecked) {
          this.alertShow("회원 ID를 체크해주세요.");
          return false;
        }
        payload["member_id"] = this.memberId;
      }
      if (this.selectStatus !== "inactivated") {
        if (this.memberName === "") {
          this.alertShow("이름을 입력해주세요.");
          return false;
        }
        if (this.memberPhone === "") {
          this.alertShow("전화번호를 입력해주세요.");
          return false;
        }
        if (this.memberEmail === "") {
          this.alertShow("이메일을 입력해주세요.");
          return false;
        }
        payload["member_name"] = this.memberName;
        payload["member_phone"] = this.memberPhone;
        payload["member_email"] = this.memberEmail;
      }

      this.is_save = true;
      await M.api(M.entry("/serials/status", encodeURIComponent(this.prd.serial_number)), payload);
      this.authStateDialog = false;
      this.is_save = false;
      this.alertShow("정상적으로 인증상태가 변경되었습니다.");
      //this.eventHub.$emit("execSearch", false);
      this.$parent.$parent.$parent.$refs.searchComponent.execSearch(false);
    },
    /**
     * 유져 유효성 체크
     */
    validateUser: async function() {
      if (this.memberId === "") {
        this.alertShow("회원ID를 다시 확인해주세요.");
        return false;
      }

      try {
        let res = await M.api(M.entry("/user/validate", this.memberId));
        if (res.exists) {
          this.alertShow("정상회원임을 체크하였습니다.");
          this.memberIdChecked = true;
        }
      } catch (e) {
        if (e.response.status === 404 || e.response.status === 500) {
          this.alertShow("회원ID를 다시 확인해주세요.");
        }
      }
    },
    changeMemberType: function(e) {
      this.memberId = "";
      this.memberIdChecked = false;
      console.log("change check", e);
      if (e === "guest") {
        this.memberIdChecked = true;
      }
    },
    changeCheckMemberShow: function() {
      this.checkMemberShow = false;
      if (this.selectStatus !== "inactivated") {
        this.checkMemberShow = true;
      }
    },
    getSerialStatus: async function(serial) {
      try {
        let data = await M.api(M.entry("/get/serials/status", encodeURIComponent(serial)));
        console.log("get serial data", data);
        if (data.cert_status !== "inactivated") {
          this.memberEmail = data.member_email ? data.member_email : "";
          this.memberName = data.member_name ? data.member_name : "";
          this.memberPhone = data.member_phone ? data.member_phone : "";
          this.memberId = data.member_id ? data.member_id : "";
        }
      } catch (e) {
        console.log("get serial error", e);
      }
    },
    getApproval: async function(data) {
      if (data.cert_status != "approved") {
        try {
          let data = await M.api(M.entry("/get/config/approval"), {});
          if (data.status == "disabled") {
            this.initTypeItems.splice(3, 1);
          }
        } catch (e) {
          //console.log(e);
        }
      }
    },
    memberOpen: function() {
      const go_url = this.moveEcUserPage(this.memberId);
      window.open(go_url, "_blank");
    },
  },
};
</script>
